jQuery(document).ready(function() {
	// load slider for Headslider

	
jQuery('.startslider').slick({
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 14000 
});



  jQuery('.imagekarusell').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    variableWidth: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  jQuery('.apartmentslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '25vw',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: '20px',
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: '20px',
        }
      }
    ]
  });


jQuery('<?xml version="1.0" encoding="UTF-8"?>\n' +
    '<svg viewBox="0 0 166.68 72.891" xmlns="http://www.w3.org/2000/svg">\n' +
    '<g transform="translate(175.54 -121) rotate(90)" data-name="Gruppe 3">\n' +
    '<path d="m160.49 152.29c-1.224-1.836-4.284-1.836-6.12 0-2.448 3.06-1.836 5.508-1.836 9.18s0.612 6.732 0.612 10.4c0.612 4.9 7.344 4.9 7.344 0 0-3.061 0.612-6.12 0.612-9.181 1.224-3.667 2.449-6.727-0.612-10.399z" data-name="Pfad 74"/>\n' +
    '<path d="m163.35 138.65c-2.448-6.732-1.224-13.464-3.06-20.2a4.25 4.25 0 0 0-7.956 0c-2.448 7.344 0 15.912 4.284 22.645 1.836 3.675 7.956 1.227 6.732-2.445z" data-name="Pfad 75"/>\n' +
    '<path d="m159.99 74.87a3.723 3.723 0 0 0-4.9 0c-3.672 3.672-2.448 8.568-2.448 13.464a99.157 99.157 0 0 0 0.612 13.464c0.612 3.672 6.732 3.672 7.344 0a82.02 82.02 0 0 0 0.612-12.24c1.228-4.896 2.452-10.404-1.22-14.688z" data-name="Pfad 76"/>\n' +
    '<path transform="matrix(-1 -.017 .017 -1 313.92 109.54)" d="m157.25 40.93a5.087 5.087 0 0 0-4.9 6.732c1.224 4.9 1.224 11.016 1.836 15.912 0.612 3.06 6.12 3.06 6.732 0 0.612-5.508 0-11.016 1.836-15.912a5.783 5.783 0 0 0-5.504-6.732z" data-name="Pfad 77"/>\n' +
    '<path transform="translate(0 -6.98)" d="m192.54 47.415c-10.788-11.726-22.515-23.452-37.056-30.957-1.876-0.939-4.222-0.939-5.629 0.938-9.85 11.726-17.355 24.86-27.674 36.117-3.753 3.753 2.345 9.381 5.628 5.629 9.382-10.319 16.417-22.515 25.8-32.834 12.2 7.5 20.639 18.293 31.427 28.143 5.158 4.691 11.726-2.345 7.504-7.036z" data-name="Pfad 78"/>\n' +
    '</g>\n' +
    '</svg>').appendTo( ".slick-next ,.slick-prev");

});

